import ajax from './index'
import apiEnv from './apiEnv'
// 获取领域
export function getDomianSelect() {
    return ajax.get(`${apiEnv.api2}/exam/domianSelect`)
}
// 获取产品
export function getProductSelect(data) {
    return ajax.get(`${apiEnv.api2}/exam/productSelect`, data)
}

// 获取二级产品
export function getSecondProductSelect(data) {
    let params = {
        "LevelType": 2,
        "ParentId": 0,
        "platform": "pcweb"
    }

    return new Promise((resolve, reject) => {

        ajax.post(`${apiEnv.api1}/api/Code/GetProductList`, params).then(res=> {
            if(res.Result == 1 && res.Data) {
                let respData = res.Data.ProductList.map(item=>{
                    return {
                        key : item.ProductId,
                        value : item.ProductName
                    }
                })
                res.Data = respData;
                resolve(res)
            }
            resolve(res)
         }).catch((err) => {
            reject();
          });
    
        })
       
}

// 获取三级产品
export function getThreeProductList(data) {
    let params = {
        "LevelType": 0,
        "platform": "pcweb",
        ...data
    }
    return  new Promise((resolve, reject) => {

     ajax.post(`${apiEnv.api1}/api/Code/GetProductList`, params).then(res=> {
        if(res.Result == 1 && res.Data) {
            let respData = res.Data.ProductList.map(item=>{
                return {
                    key : item.ProductId,
                    value : item.ProductName
                }
            })
            res.Data = respData;
            resolve(res)
        }
        resolve(res)
     }).catch((err) => {
        reject();
      });
    })
}
// 获取品牌
export function getBrandSelect() {
    return ajax.get(`${apiEnv.api2}/exam/brandSelect`)
}
// 服务类型 （服务内容）
export function getServiceSelect(data) {
    return ajax.get(`${apiEnv.api2}/exam/serviceSelect`, data)
}
// 获取关联课程
export function getCourseSelect() {
    return ajax.get(`${apiEnv.api2}/exam/courseSelect`)
}



//获取用户角色
export function listRoles(data) {
    return ajax.post(`${apiEnv.api1}/api/Account/Account/ListRoles`, data)
}
//获取用户分类
export function companyTypes(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/company/type`, data)
}


// 省市区
export function optionsArea(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/area`, data)
}
// 所属行业
export function industrys(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/industrys`, data)
}
// 所属大区
export function areaCategory(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/areaCategory`, data)
}
// 企业类型
export function companyRoles(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/companyRoles`, data)
}
// 职位
export function linkManPost(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/linkManPost`, data)
}
// 企业规模
export function scale(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/scale`, data)
}
//客户类型
export function custType(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/custType`, data)
}
//负责人类型
export function headers(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/headers`, data)
}
//季度
export function quarter(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/quarter`, data)
}